<script>
  import PropEditor from "./PropEditor.svelte";
  import AlignmentToolbar from "./AlignmentToolbar.svelte";
  import Pane from "$lib/Elements/Pane.svelte";
  import { selectedElements } from "../store";
</script>

<Pane fixedWidth>
  {#if $selectedElements.length == 0}
    <h3 class="font-semibold px-4 text-sm text-content-subtle pb-5">Nothing selected</h3>
  {:else if $selectedElements.length > 1}
    <h3 class="font-semibold px-4 text-sm text-content-subtle pb-4 mb-4 border-b">
      Multiple items selected
    </h3>
    <AlignmentToolbar />
  {:else}
    <h3 class="font-semibold border-b border-line-strong px-3 pb-4 text-sm mb-4">
      Region<span class="text-content-subtle">#{$selectedElements[0]}</span>
    </h3>
    {#key $selectedElements[0]}
      <PropEditor selected={$selectedElements[0]} />
    {/key}
  {/if}
</Pane>
